export default __webpack_public_path__ + "static/media/mechanism_long.2b1c0c1f.webp";